import React, {
    useState,
    useEffect,
    useMemo
} from "react"
import {
    Table,
    Button,
    Modal,
    Form,
    ButtonToolbar,
    IconButton,
    Message,
    toaster,
    CheckboxGroup,
    Checkbox,
    Radio,
    RadioGroup
} from "rsuite"
import PlusIcon from "@rsuite/icons/Plus"
import EditIcon from "@rsuite/icons/Edit"
import TrashIcon from "@rsuite/icons/Trash"
import {
    Loader,
    ToastMessage,
    ConfirmationAlert
} from "../../components/index"
import {
    useCreatePlatformRolesMutation,
    useLazyGetPlatformRolesQuery,
    useCreatePlatformUserMutation,
    useLazyGetPlatformUserListQuery,
    useUpdateInstitutionMetadataMutation,
    useUpdateUserMetadataMutation,
    useDeleteUserFromInstitutionMutation,
    useLazyGetInstitutionMetadataQuery
} from "../../Redux/actions/setting.action"
import {
    GetUserPrivillages,
    privilegesList
} from "../../utils/hooks"
import _ from "lodash"

const { Column, HeaderCell, Cell } = Table

function InstitutionMembers({ institutionBasicInfo, institutionMetadata, user }) {
    const [createRolesAction, createRoleState] = useCreatePlatformRolesMutation()
    const [getRolesAction, getRolesState] = useLazyGetPlatformRolesQuery()
    const [createUserAction, createUserState] = useCreatePlatformUserMutation()
    const [getUserListAction, getUserListState] = useLazyGetPlatformUserListQuery()
    const [updateUserMetadataAction, updateUserMetadataState] = useUpdateUserMetadataMutation()
    const [deleteUserAction, deleteUserState] = useDeleteUserFromInstitutionMutation()
    const [updatePlatformMetadataAction,updatePlatformMetadataState] = useUpdateInstitutionMetadataMutation()
    const [getPlatformMetadataAction,getPlatformMetadataState] = useLazyGetInstitutionMetadataQuery()

    const [status, setStatus] = useState(null)
    const [selectedUserId, setSelectedUserId] = useState(null)

    const [open, setOpen] = useState(false)
    const [openRoleModal, setOpenRoleModal] = useState(false)
    const [editingMember, setEditingMember] = useState(null)
    const [formValue, setFormValue] = useState({
        firstname: "",
        lastname: "",
        email: "",
        designation: [],
        password: ""
    })
    const [roleForm, setRoleForm] = useState({
        designation: "",
        privileges: []
    })
    const [alert, setAlert] = useState({
        open: false,
        message: "",
        title: ""
    })

    React.useEffect(()=>{
        if(user){
            let user_platform = _.get(user,"meta_data.user_platform",null)
            user_platform && getPlatformMetadataAction(user_platform)
        }
    },[user])

    useEffect(() => {
        if (institutionBasicInfo) {
            const platform_id = institutionBasicInfo.id
            platform_id && getRolesAction({ platform_id })
            platform_id && getUserListAction({ platform_id })
        }
    }, [institutionBasicInfo])
    const getRolesStatus = useMemo(() => {
        if (getRolesState.isSuccess) {
            return [
                ...getRolesState.currentData?.roles
            ]
        }
        if (getRolesState.isError) {
            return []
        }
    }, [getRolesState])
    const createRolesStatus = useMemo(() => {
        if (createRoleState.isSuccess) {
            if (institutionBasicInfo) {
                const platform_id = institutionBasicInfo.id
                platform_id && getRolesAction({ platform_id })
            }
            setOpenRoleModal(false)
            return {
                show: true,
                message: createRoleState.data?.message,
                type: "success"
            }
        }
        if (createRoleState.isError) {
            return {
                show: true,
                message: createRoleState.error.data?.detail,
                type: "error"
            }
        }
    }, [createRoleState])

    useEffect(() => {
        if (createRolesStatus) {
            setStatus(createRolesStatus)
        }
    }, [createRolesStatus])

    const stuffsEmailList = React.useMemo(()=> {
        if(getPlatformMetadataState.isSuccess){
            let emailList = _.get(getPlatformMetadataState,"currentData.metadata.meta_data.stuffs",null)
            return emailList
        }else{
            return []
        }
    },[getPlatformMetadataState])

    const platformUserListStatus = useMemo(() => {
        if (getUserListState.isSuccess) {
            let allUserList = _.get(getUserListState,"currentData.list",[])
            let finalList = Array.isArray(allUserList) && allUserList.length > 0 && allUserList.filter((item) => {
                let designation = _.get(item,"meta_data.designation","")
                if(designation !== "student"){
                    return item
                }else {
                    return null
                }
            }).filter(i => i)
            return finalList
        }
        else if (getUserListState.isError) {
            return []
        } else {
            return []
        }
    }, [getUserListState,stuffsEmailList])

    /*** Member Actions ***/
    const handleAdd = () => {
        setEditingMember(null);
        setFormValue({ name: "", role: "", email: "" });
        setOpen(true);
    };

    const handleEdit = (member) => {
        setEditingMember(member)
        setFormValue(member)
        setOpen(true)
    }

    const handleDelete = (id) => {
        setSelectedUserId(id)
        setAlert({
            open: true,
            title: "Delete confirmation",
            message: "Are you sure? do you want to delete user?"
        })
    }

    const handleSubmit = () => {
        if (!formValue.firstname || !formValue.email || !formValue.designation) {
            toaster.push(<Message type="info">All fields are required</Message>, { placement: "topCenter" })
            return
        }
        if (!institutionBasicInfo) return

        createUserAction({
            firstname: formValue.firstname,
            lastname: formValue.lastname,
            email: formValue.email,
            password: `${formValue.firstname}@12345`,
            meta_data: {
                "designation": formValue.designation,
                "user_platform": institutionBasicInfo?.id
            }
        })
        if(institutionMetadata && institutionMetadata.hasOwnProperty("meta_data")){
            let stuffs = _.get(institutionMetadata,"meta_data.stuff",[])
            if(Array.isArray(stuffs) && stuffs.length > 0 && !stuffs.includes(formValue.email)){
                stuffs = [...stuffs,formValue.email]
            }else if(Array.isArray(stuffs) && stuffs.length === 0){
                stuffs = [formValue.email]
            }
            let meta_data = {
                ...institutionMetadata.meta_data,
                "stuffs":stuffs
            }
            updatePlatformMetadataAction({
                platform_id:institutionMetadata.id,
                meta_data:meta_data
            })
        }
    }

    /*** Role Actions ***/
    const handleCreateRole = () => {
        setRoleForm({ designation: "", privileges: [] })
        setOpenRoleModal(true)
    };

    const handleRoleSubmit = () => {
        if (!roleForm.designation) {
            toaster.push(<Message type="warning">Designation is required</Message>, { placement: "topCenter" });
            return
        }
        if (roleForm.privileges.length == 0) {
            toaster.push(<Message type="warning">Please select atlease one privilege</Message>, { placement: "topCenter" });
            return
        }
        if (!institutionBasicInfo) return
        createRolesAction({
            platform_id: institutionBasicInfo.id,
            designation: roleForm.designation,
            meta_data: {
                "privileges": roleForm.privileges
            }
        })
    }
    const userAddToPlatformStatus = useMemo(() => {
        if (createUserState.isSuccess) {
            setOpen(false)
            if (institutionBasicInfo) {
                const platform_id = institutionBasicInfo.id
                platform_id && getUserListAction({ platform_id })
            }
            createUserState.reset()
            return {
                show: true,
                message: createUserState.data?.message,
                type: "success"
            }
        }
        if (createUserState.isError) {
            return {
                show: true,
                message: createUserState.error.data?.detail,
                type: "error"
            }
        }
    }, [createUserState])

    useEffect(() => {
        if (userAddToPlatformStatus) {
            setStatus(userAddToPlatformStatus)
        }
    }, [userAddToPlatformStatus])

    function updateUserMetadata() {
        if (!editingMember) {
            toaster.push(<Message type="info" >User info missing</Message>, { placement: "topCenter" })
            return
        }
        const privilege_user = GetUserPrivillages()
        const platform_privillages = getRolesStatus?.length > 0 && getRolesStatus.find((item) => item.designation === privilege_user)

        if((!privilege_user || !platform_privillages) && privilege_user !== "admin"){
            toaster.push(<Message type="info" >Not Allow to update user details!.Please contact with admin user.</Message>,{placement:"topCenter"})
            return
        }
        
        const privileges = _.get(platform_privillages,"meta_data.privileges",[])
        if(privilege_user !== "admin" && Array.isArray(privileges) && !privileges.includes("Upload Content")){
            toaster.push(<Message type="info" >Not Allow to update user details!.Please contact with admin.</Message>,{placement:"topCenter"})
            return
        }

        const meta_data = {
            ...editingMember.meta_data,
            "designation": formValue.designation
        }
        let data = {
            ...editingMember,
            meta_data: meta_data
        }
        updateUserMetadataAction({
            userRef: data.id,
            userInfo: data
        })
    }

    const updateUserMetadataStatus = useMemo(() => {
        if (updateUserMetadataState.isSuccess) {
            let status = _.get(updateUserMetadataState, "data.message", "")
            setEditingMember(null)
            setOpen(false)
            if (institutionBasicInfo) {
                const platform_id = institutionBasicInfo.id
                platform_id && getRolesAction({ platform_id })
                platform_id && getUserListAction({ platform_id })
            }
            return {
                show: true,
                message: status,
                type: "success"
            }
        }
        if (updateUserMetadataState.isError) {
            return {
                show: true,
                message: "Error while update the user metadata!",
                type: "error"
            }
        }
    }, [updateUserMetadataState])
    useEffect(() => {
        if (updateUserMetadataStatus) {
            setStatus(updateUserMetadataStatus)
        }
    }, [updateUserMetadataStatus])

    const deleteUserStatus = useMemo(() => {
        if (deleteUserState.isSuccess) {
            if (institutionBasicInfo) {
                const platform_id = institutionBasicInfo.id
                platform_id && getRolesAction({ platform_id })
                platform_id && getUserListAction({ platform_id })
            }
            setSelectedUserId(null)
            setAlert({
                open: false,
                title: "",
                message: ""
            })
            return {
                show: true,
                message: "User deleted success!",
                type: "success"
            }
        }
        if (deleteUserState.isError) {
            return {
                show: true,
                message: "Error while delete the user!",
                type: "error"
            }
        }
    }, [deleteUserState])

    useEffect(()=>{
        if(deleteUserStatus){
            setStatus(deleteUserStatus)
        }
    },[deleteUserStatus])



    return (
        <div
            style={{
                padding: 20,
                display: "flex",
                flexDirection: "column",
                gap: 20,
                background: "#f9fafb",
                minHeight: "100vh",
            }}
        >
            <div
                style={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    flexWrap: "wrap",
                    gap: 10,
                }}
            >
                <h3 style={{ margin: 0 }}>Institution Members</h3>
                <div
                    style={{
                        display: "flex",
                        flexDirection: "row",
                        justifyContent: "center",
                        alignItems: "center",
                        gap: "8px",
                    }}
                >
                    <Button appearance="primary" startIcon={<PlusIcon />} onClick={handleAdd}>
                        Add Member
                    </Button>
                    <Button appearance="ghost" startIcon={<PlusIcon />} onClick={handleCreateRole}>
                        Create Role
                    </Button>
                </div>
            </div>

            {/* Members Table */}
            <div style={{ overflowX: "auto", background: "#fff", borderRadius: 8 }}>
                <Table data={platformUserListStatus} autoHeight bordered cellBordered wordWrap style={{ minWidth: 600 }}>
                    <Column flexGrow={1}>
                        <HeaderCell>First Name</HeaderCell>
                        <Cell dataKey="firstname" />
                    </Column>
                    <Column flexGrow={1}>
                        <HeaderCell>Last Name</HeaderCell>
                        <Cell dataKey="lastname" />
                    </Column>
                    <Column flexGrow={1}>
                        <HeaderCell>Designation</HeaderCell>
                        <Cell dataKey="meta_data.designation" />
                    </Column>
                    <Column flexGrow={1}>
                        <HeaderCell>Email</HeaderCell>
                        <Cell dataKey="email" />
                    </Column>
                    <Column width={160} fixed="right">
                        <HeaderCell>Actions</HeaderCell>
                        <Cell>
                            {(rowData) => (
                                <ButtonToolbar>
                                    <IconButton
                                        icon={<EditIcon />}
                                        appearance="subtle"
                                        onClick={() => handleEdit(rowData)}
                                    />
                                    <IconButton
                                        icon={<TrashIcon />}
                                        appearance="subtle"
                                        color="red"
                                        onClick={() => handleDelete(rowData.id)}
                                    />
                                </ButtonToolbar>
                            )}
                        </Cell>
                    </Column>
                </Table>
            </div>

            {/* Add/Edit Member Modal */}
            <Modal open={open} onClose={() => setOpen(false)} size="xs">
                <Modal.Header>
                    <Modal.Title>{editingMember ? "Edit Member" : "Add New Member"}</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Form
                        fluid
                        formValue={formValue}
                        onChange={setFormValue}
                        style={{ display: "flex", flexDirection: "column", gap: 0 }}
                    >
                        <Form.Group controlId="firstname">
                            <Form.ControlLabel>First Name</Form.ControlLabel>
                            <Form.Control name="firstname" placeholder="Enter first name" />
                        </Form.Group>
                        <Form.Group controlId="lastname">
                            <Form.ControlLabel>Last Name</Form.ControlLabel>
                            <Form.Control name="lastname" placeholder="Enter last name" />
                        </Form.Group>
                        <Form.Group controlId="email">
                            <Form.ControlLabel>Email</Form.ControlLabel>
                            <Form.Control name="email" type="email" placeholder="Enter email" />
                        </Form.Group>
                        <Form.Group controlId="role">
                            <Form.ControlLabel>Select Designation</Form.ControlLabel>
                            <RadioGroup
                                name="designation"
                                value={formValue.designation}
                                onChange={(val) =>
                                    setFormValue((prev) => ({
                                        ...prev,
                                        designation: val
                                    }))
                                }
                            >
                                {Array.isArray(getRolesStatus) &&
                                    getRolesStatus.map((p) => (
                                        <Radio key={p.id} value={p.designation}>
                                            {p.designation}
                                        </Radio>
                                    ))}
                            </RadioGroup>
                        </Form.Group>
                    </Form>
                </Modal.Body>
                <Modal.Footer>
                    <Button onClick={editingMember ? updateUserMetadata : handleSubmit} appearance="primary">
                        {editingMember ? "Update" : "Add"}
                    </Button>
                    <Button onClick={() => setOpen(false)} appearance="subtle">
                        Cancel
                    </Button>
                </Modal.Footer>
            </Modal>

            {/* Create Role Modal */}
            <Modal open={openRoleModal} onClose={() => setOpenRoleModal(false)} size="sm">
                <Modal.Header>
                    <Modal.Title>Create Role</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Form
                        fluid
                        formValue={roleForm}
                        onChange={setRoleForm}
                        style={{ display: "flex", flexDirection: "column", gap: 10 }}
                    >
                        <Form.Group controlId="designation">
                            <Form.ControlLabel>Designation</Form.ControlLabel>
                            <Form.Control name="designation" placeholder="e.g., Admin, Teacher" />
                        </Form.Group>
                        <Form.Group controlId="privileges">
                            <Form.ControlLabel>Privileges</Form.ControlLabel>
                            <CheckboxGroup
                                name="privileges"
                                value={roleForm.privileges}
                                onChange={(val) => setRoleForm((prev) => ({ ...prev, privileges: val }))}
                            >
                                {privilegesList.map((p) => (
                                    <Checkbox key={p} value={p}>
                                        {p}
                                    </Checkbox>
                                ))}
                            </CheckboxGroup>
                        </Form.Group>
                    </Form>
                </Modal.Body>
                <Modal.Footer>
                    <Button onClick={handleRoleSubmit} appearance="primary">
                        Save Role
                    </Button>
                    <Button onClick={() => setOpenRoleModal(false)} appearance="subtle">
                        Cancel
                    </Button>
                </Modal.Footer>
            </Modal>
            {
                (
                    getRolesState.isLoading ||
                    createRoleState.isLoading ||
                    createUserState.isLoading ||
                    getUserListState.isLoading ||
                    updateUserMetadataState.isLoading ||
                    deleteUserState.isLoading ||
                    updatePlatformMetadataState.isLoading ||
                    getPlatformMetadataState.isLoading
                ) && (
                    <Loader show={true} />
                )
            }
            {
                status && status.show && (
                    <ToastMessage
                        {...status}
                        onClose={() => {
                            setStatus(null)
                        }}
                    />
                )
            }
            {
                alert.open && (
                    <ConfirmationAlert
                        {...alert}
                        onConfirm={() => {
                            if (selectedUserId) {
                                deleteUserAction({
                                    user_ref: selectedUserId
                                })
                            }
                        }}
                        onCancel={() => {
                            setAlert({
                                open: false,
                                title: "",
                                message: ""
                            })
                        }}
                    />
                )
            }
        </div>
    );
}

export default InstitutionMembers
